import React from 'react';
import {
  getNote2_preBiosySerumPsa,
  getNote3_clinicalStage,
} from '../../constants/modal_content/PART_1_CLINICAL_INFORMATION_SPECIMEN_RECEIPT';
import ModalInformation from '../../components/modals/ModalInformation';


export const fields = [
  {
    name: 'previousHistory',
    label: (
      <>

        Previous history of prostate cancer &nbsp;
        <i>(including the Gleason grade and score of previous specimens if known)</i>
      </>
    ),
    multiline: true,
  },
  {
    name: 'previousTherapy',
    label: (
      <>

        Previous therapy&nbsp;
        <i>(specify)</i>
      </>
    ),
    multiline: true,
  },
  {
    name: 'previousBiopsy',
    label: (
      <>

        Previous biopsy&nbsp;
        <i>(specify date and where performed)</i>
      </>
    ),
    multiline: true,
  },
  {
    name: 'other',
    label: (
      <>

        Other&nbsp;
        <i>(specify)</i>
      </>
    ),
    multiline: true,
  },
  {
    name: 'preBiopsySerumPsa',
    label: (
      <>

        PRE-BIOPSY SERUM PSA
        <ModalInformation>{getNote2_preBiosySerumPsa()}</ModalInformation>
      </>
    ),
    multiline: false,
  },

  {
    name: 'clinicalStage',
    label: (
      <>

        CLINICAL STAGE
        <ModalInformation>{getNote3_clinicalStage()}</ModalInformation>
      </>
    ),
    multiline: false,
  },
];
